import React from 'react';
import classNames from 'classnames';
import api from '../../utils/api';
import { validEmail } from '../../utils/validator';

class Actions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {showForm: false, formSent: false, emailAddress: '', valid: true};
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.displayForm = this.displayForm.bind(this);
  }

  handleEmailChange(event) {
    event.preventDefault;
    return;
    let email = event.target.value;
    this.setState({emailAddress: email});
    if(validEmail(email) && !this.state.valid) {
      this.setState({ valid: true });
    }
  }

  handleSubmit (event) {
    event.preventDefault();
    let email = this.state.emailAddress.trim().toLowerCase();
    if(validEmail(email)) {
      api.createReport(this.props.id, email).then(() => {
        this.setState({formSent: true, emailAddress: '', showForm: false});
        setTimeout(() => {
          this.setState({formSent: false});
        }, 2500);
      }).catch(() => {
        this.setState({formSent: false});
      });
    } else {
      this.setState({ valid: false });
      this.refs.input.focus();
    }
  }

  displayForm() {
   this.setState({showForm: true});
  }

  render() {
    let form, formSuccess;
    if(this.state.showForm) {
      let formClassName = classNames(
        'results__actions__form',
        {'is-invalid': !this.state.valid}
      );
      form = (
        <form className={formClassName} onSubmit={this.handleSubmit}>
          <div className="is-container">
            <div className="is-field">
              <div className="is-input">
                <input
                  ref="input"
                  type="text"
                  placeholder="Report generation is not active yet..."
                  value={this.state.emailAddress}
                  onChange={this.handleEmailChange}
                  readonly/>
              </div>
              <button type="submit" className="is-button"><span>Send</span></button>
            </div>
          </div>
        </form>
      );
    }
    if(this.state.formSent) {
      formSuccess = <div className="results__actions__success">Email sent, check your inbox!</div>;
    }
    let secondActionLabel = this.props.onNetlify ? 'Login to Netlify' : 'Try Netlify now for free';

    return (
      <div className="results__actions">
        <ul>
          <li className="results__actions__item"><a onClick={this.displayForm}><span>Send me a report (PDF)</span></a></li>
          <li className="results__actions__item"><a href="https://app.netlify.com/signup"><span>{secondActionLabel}</span></a></li>
        </ul>
        {form}
        {formSuccess}
      </div>
    );
  }
}

Actions.propTypes = {
  onNetlify: React.PropTypes.bool,
  id: React.PropTypes.string
};

export default Actions;



// WEBPACK FOOTER //
// ./src/components/results/Actions.js